export const modalOperate = {
  methods: {
    // 點擊光箱背景關閉
    close() {
      this.$store.commit('modal/closeModal')
    },
    // 確認
    confirm() {
      this.close()
      this.callback && this.callback()
    },
    // 取消
    cancel() {
      this.close()
      this.callback && this.callback()
    }
  }
}
